import { IncomingMessage } from "../network/protocol/types";

const POKER_SC_GAME_RESULT = "53626" as const;

export default function leagacyMessagesFilter(message: IncomingMessage) {
  return message.type !== POKER_SC_GAME_RESULT;
}
